module.exports = __webpack_public_path__ + "static/media/unstoppable-domains-logo-dark.6ccd6a66.svg";